import {initWebHeaderOuterMenuCarousel} from "./header-outer-menu-native";

$(document).ready(function() {
    initWebHeaderOuterMenuCarousel();
});
